// extracted by mini-css-extract-plugin
export default {"pageTitleBar":"PageTitleBar_pageTitleBar__EpXGH","content":"PageTitleBar_content__X5Zak","backArrow":"PageTitleBar_backArrow__02mcU","pageTitle":"PageTitleBar_pageTitle__OWqvs"};